import bdaylytics from "components/utils/analytics/bdaylytics";
import { cloudspongeProviderMap, cloudspongeSupportedProviders, providerGroups } from "components/utils/cloudsponge";
import { retryPromiseWithDelay, scriptLoaded } from "components/utils/promise";
import { decodeHtml } from "components/utils/string";
import { useQueryDict } from "hooks/app";
/* global cloudsponge */
import React, { createContext, useContext, useEffect, useState } from "react";

const CloudspongeContext = createContext({});

export const CloudspongeProvider = ({ children }) => {
  const { search } = useQueryDict();
  const [cloudspongeLoaded, setCloudspongeLoaded] = useState(false);
  const [cloudspongeError, setCloudspongeError] = useState("");

  useEffect(() => {
    loadCloudspongeScript();
  }, []);

  const loadCloudspongeScript = async () => {
    const { status } = await retryPromiseWithDelay(scriptLoaded("//api.cloudsponge.com/widget/7eb44bee6b0e2e93ba895fc23298f781f777c227.js"));
    if (status === "error") {
      setCloudspongeError("Error loading cloudsponge");
    }
    setCloudspongeLoaded(true);
  };

  const onShowMore = () => {
    cloudsponge.init({ sources: cloudspongeSupportedProviders });
    cloudsponge.launch();
    const cloudSpongeContainer = document.getElementById("cloudsponge-address-book");
    cloudSpongeContainer.classList.add("large");
    bdaylytics.track("Scraper Show More", { search }, "SCRAPER", "Click");
    return false;
  };

  const afterInit = () => {
    const node = document.getElementById("cloudsponge-providers-list");
    const listItem = document.createElement("li");
    const button = document.createElement("button");
    const buttonTitle = document.createElement("span");
    buttonTitle.innerHTML = "Show More";
    buttonTitle.className = "show-more-button-title";
    button.innerHTML = '<span style="margin-top: -8px;display: flex; align-items: center;justify-content: center;">+</span>';
    button.className = "show-more-button";
    listItem.onclick = onShowMore;
    listItem.append(button);
    listItem.append(buttonTitle);
    node.appendChild(listItem);
  };

  const beforeDisplayContacts = (contacts, source, owner) => {
    const processedContacts = contacts.slice().map((contact) => {
      const processedContact = { ...contact };
      processedContact.first_name = decodeHtml(processedContact.first_name);
      processedContact.last_name = decodeHtml(processedContact.last_name);
      return processedContact;
    });
    cloudsponge.showContacts(processedContacts, source, owner);

    bdaylytics.track("Scraper Existing Contacts", { search, count: contacts.length, source }, "SCRAPER");
    return true;
  };

  const beforeImport = (source) => {
    bdaylytics.track("Scraper Provider", { search, source }, "SCRAPER", "Click");
  };

  const launchCloudsponge = async (emailProviderKey, onCompleted) => {
    if (!cloudspongeLoaded || cloudspongeError) {
      return;
    }
    let sources = providerGroups.default;
    let provider = emailProviderKey;
    if (emailProviderKey && cloudspongeSupportedProviders.includes(emailProviderKey)) {
      const providerGroup = cloudspongeProviderMap[emailProviderKey];
      sources = providerGroup ? providerGroup.group : providerGroups.default;
      if (!providerGroup.canLaunch) {
        provider = null;
      }
    }
    cloudsponge.init({
      skipContactsDisplay: false,
      sources,
      beforeDisplayContacts,
      beforeImport,
      afterInit,
      afterSubmitContacts: (contacts, source, owner) => onCompleted({ contacts, source, owner }),
    });
    cloudsponge.launch(provider);
  };

  return <CloudspongeContext.Provider value={{ cloudspongeLoaded, cloudspongeError, launchCloudsponge }}>{children}</CloudspongeContext.Provider>;
};

export const useCloudsponge = () => useContext(CloudspongeContext);
